// @flow

import * as React from 'react'

type Props = {
  name: string,
  className?: string,
}

export default (props: Props) => {
  const {name, className, ...otherProps} = props
  const classNameConcat = className ? `${name} ${className}` : name
  return (
    <svg className={classNameConcat} {...otherProps}>
      <use xlinkHref={`#${name}`} />
    </svg>
  )
}
